export default "__VITE_ASSET__nf4q9S84__"